import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import { ApiError } from "@/services/api";
import {
  ConfirmContractorVisit,
  ReadContractorVisit,
} from "@/types/contractorVisit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiErrorDescription } from "@/lib/utils/getApiErrorDescription";

export const useConfirmContractorVisitsMutation = (
  contractorVisitId: string,
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation<ReadContractorVisit, ApiError, ConfirmContractorVisit>({
    mutationFn: (payload: ConfirmContractorVisit) =>
      ContractorVisitsService.confirm(contractorVisitId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.ContractorVisits, contractorVisitId],
      });
      toast({
        title: t("projectContractorVisits.success.confirm"),
      });
    },
    onError: (error) => {
      toast({
        title: t("projectContractorVisits.errors.confirm"),
        description: getApiErrorDescription(error, t),
        variant: "destructive",
      });
    },
  });
};
